import { usePreferences } from '@engagespot/react-hooks';

export const useHasPreferences = () => {
  const { preferences } = usePreferences();
  const hasPreferences =
    preferences?.categories && preferences?.categories?.length > 0;

  return hasPreferences;
};
